/**
 * Returns a redirect target that is safe to hand to router.push/replace.
 * Rejects anything that isn't a non-looping internal absolute path.
 * Shared by the auth guard and the Error view to keep their rules in sync.
 */
export function resolveSafeFrom(fullPath: string | null | undefined): string | null {
  if (!fullPath || typeof fullPath !== "string") return null;
  if (!fullPath.startsWith("/")) return null;
  if (fullPath.startsWith("//")) return null;
  if (isRouteMatch(fullPath, "/error")) return null;
  if (fullPath === "/" || isRouteMatch(fullPath, "/login")) return null;
  return fullPath;
}

function isRouteMatch(fullPath: string, base: string): boolean {
  if (fullPath === base) return true;
  const next = fullPath[base.length];
  return fullPath.startsWith(base) && (next === "/" || next === "?" || next === "#");
}
